import { HttpClient } from '../httpClient';
import DistrictsResponse from '../responses/districtsResponse';
import DistrictResponse from '../responses/districtResponse';
import DistrictProgramOptionsResponse from '../responses/districtProgramOptionsResponse';
import { BaseResponse, DataResponse } from '../responses/baseResponse';
import DistrictRequest from '../requests/districtRequest';
import TherapyTeam from '../models/therapyTeam';
import District from '../models/district';
import DistrictBillingSpecialist from '../models/districtBillingSpecialist';
import moment from 'moment';
import { selectOption } from '../../types/selectOption';
import TimesheetDistrictsResponse from '../responses/timesheetDistrictsWrap';

const httpClient = new HttpClient();

export const getDistricts = async () => {
  return httpClient.get<DistrictsResponse>({
    url: '/v1/Districts',
    requiresToken: true,
  });
};

export const getTimesheetDistricts = async () => {
  return httpClient.get<TimesheetDistrictsResponse>({
    url: '/v1/Districts/timesheetDistricts',
    requiresToken: true,
  });
};

export const getDistrict = async (districtId: number) => {
  return httpClient.get<DistrictResponse>({
    url: `/v1/Districts/${districtId}`,
    requiresToken: true,
  });
};

export const createDistrict = async (districtrequest: DistrictRequest) => {
  return httpClient.post<DistrictResponse>({
    url: '/v1/admin/Districts',
    payload: districtrequest,
    requiresToken: true,
  });
};

export const updateDistrict = async (
  districtId: number,
  districtrequest: DistrictRequest
) => {
  return httpClient.put<BaseResponse>({
    url: `/v1/admin/Districts/${districtId}`,
    payload: districtrequest,
    requiresToken: true,
  });
};

export const deleteDistrict = async (districtId: number) => {
  return httpClient.delete<BaseResponse>({
    url: `/v1/admin/Districts/${districtId}`,
    requiresToken: true,
  });
};

export const getTherapistDistricts = async (month: number | undefined, year: number | undefined, therapistId?: number | undefined) => {
  if(month === undefined)
    month = moment().month();
  if(year === undefined)
    year = moment().year();

  return httpClient.get<DistrictsResponse>({
    url: `/v1/Districts/TherapistDistricts?month=${month}&year=${year}${therapistId ? `&therapistId=${therapistId}` : ''}`,
    requiresToken: true,
  });
};

export const getTherapistDistrictsByCaseloadId = async (caseloadId: number) => {
  return httpClient.get<DistrictsResponse>({
    url: `/v1/Districts/TherapistDistricts/Caseload/${caseloadId}`,
    requiresToken: true,
  });
};

export const getTherapistDistrictProgramOptions = async (month: number, year: number, disciplineId: number | null = null) => {
  if(month === undefined)
    month = moment().month();
  if(year === undefined)
    year = moment().year();

  return httpClient.get<DistrictProgramOptionsResponse>({
    url: `/v1/Districts/TherapistDistrictProgramOptions?month=${month}&year=${year}${disciplineId ? `&disciplineId=${disciplineId}` : ''}`,
    requiresToken: true,
  });
};

export const getTherapistPeriodDistrictProgramOptions = async (start: Date | string, end: Date | string, disciplineId: number | null = null) => {
  return httpClient.get<DistrictProgramOptionsResponse>({
    url: `/v1/Districts/TherapistPeriodDistrictProgramOptions?start=${moment(start).format("YYYY-MM-DD HH:mm:ss")}&end=${moment(end).format("YYYY-MM-DD HH:mm:ss")}${disciplineId ? `&disciplineId=${disciplineId}` : ''}`,
    requiresToken: true,
  });
};

export const getTherapyTeam = async (districtId: number) => {
  return httpClient.get<DataResponse<TherapyTeam>>({
    url: `/v1/Admin/Districts/${districtId}/TherapyTeam`,
    requiresToken: true,
  });
};

export const getDistrictsByTherapist = async () => {
  return httpClient.get<DataResponse<District[]>>({
    url: `/v1/Admin/Districts/ByTherapist`,
    requiresToken: true,
  });
};

export const getDistrictsByBillingSpecialist = async () => {
  return httpClient.get<DataResponse<District[]>>({
    url: `/v1/Admin/Districts/ByBillingSpecialist`,
    requiresToken: true,
  });
};

export const getDistrictBillingSpecialists = async (districtId: number) => {
  return httpClient.get<DataResponse<DistrictBillingSpecialist[]>>({
    url: `/v1/Districts/${districtId}/BillingSpecialists`,
    requiresToken: true,
  });
};

export const getDistrictsCount = async () => {
  return httpClient.get<DataResponse<number>>({
    url: `/v1/Districts/GetCount`,
    requiresToken: true,
  });
};

export const getDistrictOptions = async () => {
  return httpClient.get<DataResponse<selectOption[]>>({
    url: `/v1/Districts/Options`,
    requiresToken: true,
  });
};